module.exports = __webpack_public_path__ + "assets/img/close.75bd30da.svg";